class QtySelector extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input');
    if (!input) return;

    input.addEventListener('change', ({ target }) => {
      const value = target.value;
      const min = target.getAttribute('min');
      const max = target.getAttribute('max');

      if (value.startsWith('0'))
        target.value = 0;

      if (min && +value < +min)
        target.value = min;

      if (max && +value > +max)
        target.value = max;
    });

    const buttons = this.querySelectorAll('button');
    buttons.forEach((btn) => {
      btn.addEventListener('click', ({ target }) => {
        const attr = target.dataset.adjust;
        const min = input.getAttribute('min');
        const max = input.getAttribute('max');
        const value = attr === 'decrement' ? +input.value - 1 : +input.value + 1;

        if (min && value < +min) return;
        if (max && value > +max) return;

        input.value = value;
        input.dispatchEvent(new CustomEvent('change'));
      });
    });
  }
}

customElements.define('widget-qty-selector', QtySelector);